/* global gtag */
/* global DetectUserAgent */
import { useEffect, useMemo } from "react";

import UserPresenter from "presenters/UserPresenter";
import MakePresenter from "presenters/MakePresenter";
import useUsers from "hooks/useUsers";
import useMakes from "hooks/useMakes";
import useSettings from "hooks/useSettings";

const useGA4 = () => {
  const { currentUser } = useUsers();
  const {
    settings: { googleAnalytics4Key },
  } = useSettings();
  const { make } = useMakes();

  const configParams = useMemo(() => {
    return {
      user_properties: {
        loggedIn: UserPresenter.isRegistered(currentUser) ? "yes" : "no",
        statusMembership: UserPresenter.isPaid(currentUser) ? "member" : "nonMember",
        userIsRecipient: MakePresenter.isRecipient(make) ? "yes" : "no",
        user_id: currentUser ? currentUser.id : null,
      },
    };
  }, [currentUser, make]);

  useEffect(() => {
    if (!DetectUserAgent.isPrerender()) {
      gtag("config", googleAnalytics4Key, configParams);
    }
  }, [configParams]);
};

export default useGA4;
